import { css } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

import { media } from '@atlaskit/primitives';

import { wacToken } from '@/libraries/design/foundations';

import { getIsGwp10027NonprofitPricingPage } from '../feature-gates.ts';

const bannerContainerCss = css({
	backgroundColor: wacToken('color.primary.blue'),
	display: 'flex',
	justifyContent: 'center',
	textAlign: 'left',
	padding: '16px',
	[media.above.sm]: {
		textAlign: 'center',
	},
});

const bodyCss = css({
	color: '#ffffff',
	fontSize: '16px',
	margin: '0',
	maxWidth: '768px',
	width: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'.link-wrapper': {
		display: 'inline',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'.link-modifier': {
		textDecoration: 'underline',
	},
});

export const Banner = () => {
	const isGwp10027 = getIsGwp10027NonprofitPricingPage();

	return (
		<div css={bannerContainerCss}>
			<div css={bodyCss}>
				{isGwp10027 && (
					<FormattedMessage
						id="NonprofitPage.banner.body.isGwp10027"
						defaultMessage="Small social impact teams can now access Teamwork Collection apps at 100% off."
					/>
				)}

				{!isGwp10027 && (
					<FormattedMessage
						id="NonprofitPage.banner.body.gwp7869"
						defaultMessage="Social Enterprises are now eligible for Atlassian’s discounted apps and support programs!"
					/>
				)}
			</div>
		</div>
	);
};
